import api from "../../adapters/api";

const initialState = {
  hasAccount: false,
  loggedIn: false,
  status: null,
  accountAddress: localStorage.getItem('exrWalletID')||'',
  racerID: localStorage.getItem('exrRacerID')||'',
  // accountAddress: localStorage.getItem('testerEXRWalletID')||'',
  // racerID: localStorage.getItem('testerEXRRacerID')||'',
  infoboxHowTo: 1
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ACCOUNT_ADDRESS":
      return {
        ...state,
        accountAddress: action.payload,
      };

    case "SET_STATUS":
      return {
        ...state,
        status: action.payload,
      };
    
    case "SET_RACER_ID":
      return {
        ...state,
        racerID: action.payload,
      };
    
    case "SET_RACER_LOGIN":
      return {
        ...state,
        racerID: action.payload.racer_id,
        accountAddress: action.payload.wallet_id,
      };
      
    default:
      return state;
  }
};

export default accountReducer;
